import React from "react";
import { Box, Typography, Button, Grid, CircularProgress } from "@mui/material";
import { Add } from "@mui/icons-material";
import { UserAddress } from "./controller";
import { AddressCard } from "./AddressCard";

interface AddressListProps {
  addresses: UserAddress[];
  onAdd: () => void;
  onEdit: (address: UserAddress) => void;
  onDelete: (address: UserAddress) => void;
  onSelect: (id: number) => void;
  onSetDefault: (address: UserAddress) => void;
  selectedId?: number;
  isLoading?: boolean;
}

export const AddressList: React.FC<AddressListProps> = ({
  addresses,
  onAdd,
  onEdit,
  onDelete,
  onSelect,
  onSetDefault,
  selectedId,
  isLoading = false,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap={'wrap'} gap={1}>
        <Typography variant="h6" fontWeight={600}>
          Meus Endereços
        </Typography>
        <Button variant="contained" startIcon={<Add />} onClick={onAdd} size="small">
          Novo Endereço
        </Button>
      </Box>

      {isLoading && (
        <Box display="flex" justifyContent="center" py={2}>
          <CircularProgress size={24} />
        </Box>
      )}

      <Grid container spacing={2}>
        {addresses.map((address) => (
          <Grid item xs={12} xl={6} key={address.id}>
            <AddressCard
              address={address}
              onEdit={onEdit}
              onDelete={onDelete}
              onSelect={onSelect}
              onSetDefault={onSetDefault}
              selected={address.id === selectedId}
            />
          </Grid>
        ))}
      </Grid>

      {addresses.length === 0 && !isLoading && (
        <Typography color="text.secondary" align="center" mt={2}>
          Nenhum endereço cadastrado.
        </Typography>
      )}
    </Box>
  );
};

export default AddressList;
